import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const QuestionModalContent = styled.div`
    display: flex;
    overflow-y: auto;
    height: 90vh;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
    ${device.md} {
        flex-direction: row;
        height: 75vh;
    }
    background-color: ${colourScheme.primaryLight};
    text-align: center;
    align-items: center;
`;

export const VideoContainer = styled.div`
    display: flex;
    justify-content: center;
    height: 100%;
    video {
        width: auto;
        height: 100%;
        border-radius: 0.5rem;
    }
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;

    text-align: left;
    align-self: center;

    gap: 1rem;

    ul {
        padding: 0;
        list-style-position: inside;
    }

    ul > li {
        padding-bottom: 0.25rem;
    }
`;
